import { Component, Input, OnInit } from '@angular/core';
import { LinkService } from '@services/link.service';
import { TabContents } from '../tabs.interface';
import { Page } from '@bloomreach/spa-sdk/';
import { Card } from '@frk/eds-components';

@Component({
  selector: 'ft-tabs-media-cards-section',
  templateUrl: './tabs-media-cards-section.component.html',
})
export class TabsMediaCardsSectionComponent implements OnInit {
  /**
   * The Bloomreach page
   */
  @Input() page!: Page;
  /**
   * Page Section content
   */
  @Input() content: TabContents;

  /**
   * Cards Array
   */
  cards: Array<Card>;

  /**
   * Number of Columns
   */
  columns = 3;

  /**
   * margin bottom
   */
  spacingBottom: string;

  constructor(private ctaLinkService: LinkService) {}

  ngOnInit() {
    if (this.content?.cardCompound) {
      if (
        this.content.cardCompound.length === 2 ||
        this.content.cardCompound.length === 4
      ) {
        this.columns = 2;
      }

      if (this.content.cardCompound.length >= 5) {
        this.columns = 3;
      }
      this.spacingBottom = this.content?.spacingBottom;
      this.cards = this.createCardGroups(this.content.cardCompound);
      this.cards = this.formatCardURL(this.cards.flat());
    }
  }

  /**
   * Split cards into groups
   * @param cards - cards array
   */
  private createCardGroups(array: Card[]): Card[] {
    const cardGroups = [];
    let index = 0;
    while (index < array.length) {
      cardGroups.push(array.slice(index, this.columns + index));
      index += this.columns;
    }
    return cardGroups;
  }

  private formatCardURL(cards): Card[] {
    const newCards: Card[] = [];
    for (const card of cards) {
      newCards.push({
        ...card,
        href: this.ctaLinkService.getHref(this.page, card?.link, null),
      });
    }
    return newCards;
  }
}
